;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .factory('vulnDiscussionService', vulnDiscussionServiceFactory)

  function vulnDiscussionServiceFactory($translate, confirmModal) {
    'ngInject'

    var transl = {
      title_pleaseConfirmAction: $translate.instant(
        'title_pleaseConfirmAction'
      ),
      detail_deleteNote_confirmation: $translate.instant(
        'detail_deleteNote_confirmation'
      ),
      action_delete: $translate.instant('action_delete'),
      action_cancel: $translate.instant('action_cancel')
    }

    return {
      deleteNote: deleteNote
    }

    function deleteNote() {
      return confirmModal.open({
        title: transl.title_pleaseConfirmAction,
        message: transl.detail_deleteNote_confirmation,
        dialogOptions: {
          size: 'sm',
          yes: transl.action_delete,
          no: transl.action_cancel
        }
      })
    }
  }
})()
